interface GenerateCallbackUrlParams {
  url: string;
  result: 'success' | 'error' | 'cancellation';
  issueId?: string;
}
export const generateCallbackUrl = (
  params: GenerateCallbackUrlParams,
): string => {
  const { url, result, issueId } = params;
  const urlParams = new URLSearchParams();
  urlParams.append('result', result);
  if (issueId) {
    urlParams.append('issueId', issueId);
  }
  return `${url}?${urlParams.toString()}`;
};
